import React from "react";
import Marquee from "react-fast-marquee";
import ctl from "@netlify/classnames-template-literals";

import { testimonialsSection } from "config/drivers";
import { Ntext } from "components";

import { TestimonialCard } from "./testimonial-card";

const { title, description, testimonials } = testimonialsSection;

const NombaQRTestimonials = () => {
  return (
    <section className={wrapperStyle}>
      <Ntext
        value="TESTIMONIALS"
        color="secondary-700"
        className="!font-bold !tracking-[3px]"
        variant="text3"
      />
      <Ntext
        value={title}
        color="n-smoky"
        className="!font-medium md:!leading-[56px] !-tracking-[2px] text-center px-6 !mt-4"
        variant="h2"
      />
      <Ntext
        color="n-smoky"
        value={description}
        className="text-center max-w-[696px] px-6 !mt-6"
        variant="text3"
      />
      <Marquee className="flex mt-[120px]" pauseOnClick>
        {
          testimonials.map(testimonial => (
            <TestimonialCard key={testimonial.testimony} {...testimonial} />
          ))
        }
      </Marquee>
    </section>
  );
};

const wrapperStyle = ctl(`
  flex
  flex-col
  lg:pb-[180px]
  bg-secondary
  items-center
  space-y-16
  pb-[118px]
  pt-[60px]
  w-screen
  relative
  lg:pt-40
`);

export { NombaQRTestimonials };
